/** The native overhead warning gauge, kept distinct from the always-visible
 * vitals card (`RefreshGauge` .. `DisableShowAlways`, `uiplayergauge.py:34-60`). */

import { elem, installChrome } from "./chrome";

/** `MakeGauge(100, "red")` fixes the native gauge's width
 *  (`uiplayergauge.py:13-17`); the class is `ui.Gauge`'s own three-piece slot
 *  and red fill, drawn from the chrome. */
const PLAYER_GAUGE_WIDTH = 100;

export class PlayerGauge {
  readonly element: HTMLElement;
  private readonly fill: HTMLElement;
  private showAlways = false;

  constructor(container: HTMLElement) {
    const doc = container.ownerDocument;
    installChrome(doc);
    if (doc.getElementById("player-gauge-style") === null) {
      const style = doc.createElement("style");
      style.id = "player-gauge-style";
      style.textContent =
        `.player-gauge{position:absolute;width:${PLAYER_GAUGE_WIDTH}px;pointer-events:none}`;
      doc.head.append(style);
    }
    this.element = elem(doc, "div", "player-gauge m2-gauge");
    this.element.setAttribute("role", "meter");
    this.fill = elem(doc, "span", "m2-gauge-fill");
    this.element.append(this.fill);
    container.append(this.element);
    this.element.hidden = true;
  }

  update(current: number, maximum: number): void {
    const valid = Number.isFinite(current) && Number.isFinite(maximum) && maximum > 0;
    const percent = valid ? Math.max(0, Math.min(100, current / maximum * 100)) : 0;
    this.fill.style.setProperty("--m2-gauge-percent", `${percent}%`);
    this.element.setAttribute("aria-valuenow", String(Math.round(Math.max(0, current))));
    this.element.setAttribute("aria-valuemax", String(Math.max(0, maximum)));
    // Legacy `RefreshGauge` hides only when curHP is strictly above half
    // (`uiplayergauge.py:46-52`); exactly 50% remains visible once shown.
    this.element.hidden = !valid || (!this.showAlways && percent > 50);
  }

  enableShowAlways(): void { this.showAlways = true; }
  disableShowAlways(): void { this.showAlways = false; }
}
